import React from 'react';
import styles from './LoadingFilters.module.css';

const InputPlaceholder = () => <div className={styles.inputPlaceholder} />;

const PlaceholderGroup = ({ count }) => (
  <>
    {Array.from({ length: count }, (_, index) => (
      <div key={index} className="col-12 mb-3 col-sm-12 mb-3 col-lg-6 mb-3 col-xl-6 mb-3 col-xxl-3 mb-3">
        <InputPlaceholder />
      </div>
    ))}
  </>
);

const LoadingFilters = () => {
  return (
    <div className="container-fluid p-0">
      <div className="container-fluid ps-0 pe-0 pt-2 pb-0 bg-white">
        <div className="row p-0 m-0 align-items-center">
          <div className="col-7 col-sm-8 mb-3 col-md-12 col-lg-12 col-xl-12 col-xxl-6">
            <InputPlaceholder />
          </div>
          <PlaceholderGroup count={2} />
        </div>
      </div>

      <div className="container-fluid pt-0" style={{ backgroundColor: 'white' }}>
        <div className="row" style={{ width: 'auto' }}>
          <PlaceholderGroup count={8} />
        </div>
      </div>
    </div>
  );
};

export default LoadingFilters;
